import { defineStore } from "pinia"

interface ISnackbarMessage {
  text: string
  type: "success" | "error" | "warning"
  timeout?: number
  textAlign?: "left" | "center"
}

export const useSnackbarStore = defineStore("snackbarStore", {
  state: () => ({
    messages: [] as ISnackbarMessage[],
  }),

  actions: {
    showMessage(message: ISnackbarMessage) {
      this.messages.push(message)
    },
  },
})
